import { useTemplateState } from './context/VideoTemplateStateContext';

export default function useVideo(id: string) {
  const { videoClips } = useTemplateState();
  return videoClips?.data?.[id];
}
